var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralInformationLocation = function SvgGeneralInformationLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#999",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5a6.75 6.75 0 0 0-6.75 6.75c0 1.09.264 2.114.721 3.025h-.007l.076.14.05.095L12 22.5l5.91-10.99.051-.096.075-.14h-.008a6.7 6.7 0 0 0 .722-3.024A6.75 6.75 0 0 0 12 1.5m0 .75c3.308 0 6 2.692 6 6 0 .937-.216 1.84-.642 2.688l-.088.179-.021.038-.71 1.32-3.22 5.989L12 20.917l-5.248-9.76-.11-.219A5.9 5.9 0 0 1 6 8.25c0-3.308 2.692-6 6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.25a3 3 0 1 0 0 6 3 3 0 0 0 0-6M12 6c1.24 0 2.25 1.01 2.25 2.25S13.24 10.5 12 10.5 9.75 9.49 9.75 8.25 10.76 6 12 6"
  }))));
};
export default SvgGeneralInformationLocation;